
export const ADD_SOURCE= "@enquiry/ADD_SOURCE";
export const ADD_EVENT= "@enquiry/ADD_EVENT";
export const ADD_ENGAGEMENT= "@enquiry/ADD_ENGAGEMENT";
export const ADD_CATEGORISATION= "@enquiry/ADD_CATEGORISATION";
